<template>
  <el-row>
    <!-- 顶头信息 -->
    <el-row>
      <div class="top1" style="background-color: #FFF; border-bottom: solid 1px #E5E5E5;">
        <div class="top_1">
          <div class="top_1_1">
            <a class="changehands" @click="showWechatImg()" style="cursor:pointer;" >关注微信</a>
          </div>
          <div class="top_1_2">
            <ul id="sddm">
              <li style="float: right;"><a href="#">客服电话：029-68892595</a></li>
              <li style="float: right;"><a href="#">管理登录</a></li>
            </ul>
          </div>
        </div>
      </div>
    </el-row>
    <el-row style="width:70%; margin:0 auto; ">
      <el-row >
        <!-- 标签 --> 
        <el-row >
          <el-menu
            default-active="/MyBill"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">
            <el-menu-item index="/MyBill">新生缴费</el-menu-item>
            <el-menu-item index="/MyBillHistory">新生缴费历史</el-menu-item>
            <el-menu-item index="/Print">打印报道单</el-menu-item>
            <el-menu-item index="/Exit">退出</el-menu-item>
          </el-menu>
          <br>
          <br>
        </el-row>
      </el-row>
      <!-- 提示 -->
      <el-row v-show="infoVisible" class="back-up" style="background-color: #fff;">
        <!-- <mt-header fixed> -->
          <mt-button slot="left">提示</mt-button>
        <!-- </mt-header> -->
        <el-row style="height:60px;text-align:center;margin-top:30px;">
          <span style="font-size:15px;">{{info}}</span>
        </el-row>
      </el-row>
      <!-- 大图 -->
      <el-row>
        <BigImg v-show="showImg" @click="viewImg()" :imgSrc="imgSrc" style="z-index: 1001;"></BigImg>
      </el-row>
      <!-- 选宿舍 -->
      <el-row v-show="chooseDormVisible">
        <el-row style="background-color: #fff;">
          <el-row style="background-color: #fff; text-align: center;">
            <el-form :model="dormSetForm" ref="dormSetForm" label-width="90px" style="width: 50%;background-color: #fff;margin:auto">
              <el-row>
                <img class="banner-img" :src="effectDrawing" style="width: 50%; height: 150px; float: left;">
                <img class="banner-img" :src="bedDiagram"  style="width: 50%; height: 150px; float: right;">
              </el-row>
              <el-form-item label="收费标准" class="form-item">
                <span >{{ dormSetForm.price }}</span>
              </el-form-item>
              <el-form-item label="规格" class="form-item">
                <span >{{ dormSetForm.dormStandard }}</span>
              </el-form-item>
              <el-form-item label="宿舍配置" class="form-item">
                <span >{{ dormSetForm.roomSet }}</span>
              </el-form-item>
              <el-form-item label="公共配置" class="form-item">
                <span >{{ dormSetForm.pubAreaSet }}</span>
              </el-form-item>
              <el-form-item label="所在区域" class="form-item">
                <span >{{ dormSetForm.region }}</span>
              </el-form-item>
              <el-form-item label="备注" class="form-item">
                <span >{{ dormSetForm.remark }}</span>
              </el-form-item>
            </el-form>
          </el-row>
        </el-row>
        <el-row style="background-color: #fff;text-align: center;">
          <el-form :inline="global.editInline" :model="dormChooseForm" ref="dormChooseForm" :label-width="formLabelWidth" style="width: 50%;background-color: #fff;margin:auto">
            <el-form-item label="公寓" class="form-item">
              <!-- 下拉框 -->
              <el-select v-model="dormChooseForm['flatsName']" placeholder="== 请选择 ==" :disabled="getDisableEdit('flatsName', 'form')" 
                :class="Ginkgo.getEditItemClass(global.editInline)">
                <el-option v-for="option in modeSelector('Flats')" :key="option.modeId" :label="option.modeName" :value="option.modeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="宿舍类型" class="form-item">
              <!-- 下拉框 -->
              <el-select v-model="dormChooseForm['dormSet']" placeholder="== 请选择 ==" :disabled="getDisableEdit('dormSet', 'form')" 
                :class="Ginkgo.getEditItemClass(global.editInline)">
                <el-option v-for="option in modeSelector('Dorm_Set')" :key="option.modeId" :label="option.modeName" :value="option.modeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="宿舍" class="form-item">
              <!-- 下拉框 -->
              <el-select v-model="dormChooseForm['roomNo']" placeholder="== 请选择 ==" :disabled="getDisableEdit('roomNo', 'form')" 
                :class="Ginkgo.getEditItemClass(global.editInline)">
                <el-option v-for="option in modeSelector('Room')" :key="option.modeId" :label="option.modeName" :value="option.modeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="床位" class="form-item">
              <!-- 下拉框 -->
              <el-select v-model="dormChooseForm['bedNo']" placeholder="== 请选择 ==" :disabled="getDisableEdit('bedNo', 'form')" 
                :class="Ginkgo.getEditItemClass(global.editInline)">
                <el-option v-for="option in modeSelector('Bed')" :key="option.modeId" :label="option.modeName" :value="option.modeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span class="deg-title">所选床位有效期20分钟 ！！！</span>
            </el-form-item>
          </el-form>
          <el-row style="text-align:center;padding:10px 0"><el-button type="success" @click="nextStep('Dorm')">下一步</el-button></el-row>
        </el-row>
      </el-row>
      <!-- 选服装 -->
      <el-row v-show="chooseOtherVisible" style="background-color: #fff;text-align: center;">
        <el-row class="back-up">
          <img :src="size_Img" style="height:40vh;width:35vw">
          <!-- <BigImg v-if="showImg" @click="viewImg()" :imgSrc="imgSrc"></BigImg> -->
        </el-row>
        <el-row class="form_main">
          <el-form :inline="global.editInline" :model="clothChooseForm" ref="clothChooseForm" :label-width="formLabelWidth" style="width: 50%;background-color: #fff;margin:auto">
            <el-form-item label="迷彩服" class="form-item">
              <!-- 下拉框 -->
              <el-select v-model="clothChooseForm['coatSize']" placeholder="== 请选择 =="
                :class="Ginkgo.getEditItemClass(global.editInline)">
                <el-option v-for="option in modeSelector('XF_Coat_Size')" :key="option.modeId" :label="option.modeId" :value="option.modeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="迷彩衫" class="form-item">
              <!-- 下拉框 -->
              <el-select v-model="clothChooseForm['shirtSize']" placeholder="== 请选择 =="
                :class="Ginkgo.getEditItemClass(global.editInline)">
                <el-option v-for="option in modeSelector('XF_Shirt_Size')" :key="option.modeId" :label="option.modeId" :value="option.modeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="鞋子尺码" class="form-item">
              <!-- 下拉框 -->
              <el-select v-model="clothChooseForm['shoesSize']" placeholder="== 请选择 =="
                :class="Ginkgo.getEditItemClass(global.editInline)">
                <el-option v-for="option in modeSelector('XF_Shoes_Size')" :key="option.modeId" :label="option.modeId" :value="option.modeId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-row style="text-align:center;padding:10px 0">
            <el-button  type="success" @click="back('07')">上一步</el-button>
            <el-button type="success" @click="nextStep('Other')">下一步</el-button>
          </el-row>
        </el-row>
      </el-row>
      <!-- 账单信息 -->
      <el-row v-show="feeListVisible"  style="background-color: #fff;text-align: center;">
        <el-row>
          <el-form :model="curStudent" ref="curStudent" label-width="90px" label-position="left" style="width: 50%;background-color: #fff;margin:auto">
            <el-form-item label="姓名" class="form-item">
              <span >{{ curStudent.studentName }}</span>
            </el-form-item>
            <el-form-item label="身份证号" class="form-item">
              <span >{{ curStudent.uid }}</span>
            </el-form-item>
            <el-form-item label="专业"  class="form-item">
              <span >{{ curStudent.majorMatr }}</span>
            </el-form-item>
            <el-form-item label="学年"  class="form-item">
              <span >{{ curStudent.enrollmentYear }}</span>
            </el-form-item>
            <el-form-item label="应缴总额"  class="form-item" >
              <span >{{ Ginkgo.format(feeSum.payableAmount, 'money') }}</span>
            </el-form-item>
            <el-form-item label="减免总额"  class="form-item" >  
              <span >{{ Ginkgo.format(feeSum.reduceAmount, 'money') }}</span>
            </el-form-item>
            <el-form-item label="实缴总额"  class="form-item" >
              <span >{{ Ginkgo.format(feeSum.feeAmount, 'money') }}</span>
            </el-form-item>
            <el-collapse >
              <el-collapse-item title="费用明细" name="1" style="width: 100%">
                <el-row>
                  <div v-for="item in feeList" :key="item.feeNo">
                    <span class="label_detail">{{ item.feeNo }}</span><span class="label_value">{{ Ginkgo.format(item.feeAmount, 'money') }}</span>
                  </div>
                </el-row>
              </el-collapse-item>
              <el-collapse-item title="公寓用品明细" name="2" style="width: 100%">
                <el-row>
                  <div>
                    <span class="label_detail">6斤棉被</span><span class="label_value">1床</span>
                  </div>
                  <div>
                    <span class="label_detail">4斤棉被</span><span class="label_value">1床</span>
                  </div>
                  <div>
                    <span class="label_detail">5斤棉褥</span><span class="label_value">1床</span>
                  </div>
                  <div>
                    <span class="label_detail">床单</span><span class="label_value">2条</span>
                  </div>
                  <div>
                    <span class="label_detail">被套</span><span class="label_value">2床</span>
                  </div>
                  <div>
                    <span class="label_detail">枕巾</span><span class="label_value">1条</span>
                  </div>
                  <div>
                    <span class="label_detail">枕套</span><span class="label_value">1个</span>
                  </div>
                  <div>
                    <span class="label_detail">枕芯</span><span class="label_value">1个</span>
                  </div>
                  <div>
                    <span class="label_detail">暖水瓶</span><span class="label_value">1个</span>
                  </div>
                  <div>
                    <span class="label_detail">脸盆</span><span class="label_value">2个</span>
                  </div>
                </el-row>
              </el-collapse-item>
              <el-collapse-item title="军训用品明细" name="3" style="width: 100%">
                <el-row>
                  <div>
                    <span class="label_detail">迷彩服</span><span class="label_value">1套</span>
                  </div>
                  <div>
                    <span class="label_detail">迷彩衫</span><span class="label_value">1件</span>
                  </div>
                  <div>
                    <span class="label_detail">军帽</span><span class="label_value">1顶</span>
                  </div>
                  <div>
                    <span class="label_detail">军鞋</span><span class="label_value">1双</span>
                  </div>
                  <div>
                    <span class="label_detail">马扎</span><span class="label_value">1个</span>
                  </div>
                </el-row>
              </el-collapse-item>
            </el-collapse>
            <el-form-item>
              <span class="deg-title">所选床位即将失效，请尽快支付 ！！！</span>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row style="text-align:center;padding:10px 0">
          <el-button type="success" @click="back('08')">上一步</el-button>
          <el-button type="primary" @click="toPay()" v-if="feePayType_UN">银联支付</el-button>
        </el-row>
      </el-row>
      <!-- 历史查询结果窗体 -->
      <el-row v-show="feeListHistoryVisible">
        <el-table ref="resultTable" :data="tableData"
          style="width: 100%; margin-top: 10px;" @sort-change="handleSortChangeHistory" highlight-current-row stripe border :height="global.tableHeight"
        >
          <el-table-column type="index" fixed width="60">
          </el-table-column>
          <!-- 数据列 -->
          <el-table-column
            v-for="item in getUISetQueryResult('01')" :key="item.columnName" :prop="item.columnProp" :label="item.columnDesc.split('|')[0]"
              :min-width="item.colWidth" :align="item.alignType" :formatter="dataFormatHistory"
              :fixed="Ginkgo.getColumnFixed(item)" sortable="custom" header-align="center"
            v-if="getHeaderVisible(item, 1)"
          >
            <el-table-column
              v-for="item2 in getHeaderGroup(item, 2, '01')" :key="item2.columnName" :prop="item2.columnProp" :label="item2.columnDesc.split('|')[1]"
                :min-width="item2.colWidth" :align="item2.alignType" :formatter="dataFormatHistory"
                :fixed="Ginkgo.getColumnFixed(item2)" sortable="custom" header-align="center"
              v-if="getHeaderVisible(item2, 2)"
            >
              <el-table-column
                v-for="item3 in getHeaderGroup(item2, 3, '01')" :key="item3.columnName" :prop="item3.columnProp" :label="item3.columnDesc.split('|')[2]"
                  :min-width="item3.colWidth" :align="item3.alignType" :formatter="dataFormatHistory"
                  :fixed="Ginkgo.getColumnFixed(item3)" sortable="custom" header-align="center"
                v-if="getHeaderVisible(item3, 3)"
              >
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: center;" @size-change="handleSizeChangeHistory" @current-change="handleCurrentChangeHistory"
          :current-page="page.number + 1" :page-sizes="page.pageSizes" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalElements" :page-count="page.totalPages"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </el-row>
</template>
<script>

export default {
  name: 'MyBillXiFanNew', // ?
  data: function () {
    return {
      profile: 'prod',

      info: '无欠费信息！',
      imgSrc: '',
      dormList: [], // 当前可选宿舍列表
      chosenDorm: {}, // 当前选择的宿舍列表
      modeSelectList: [],

      keyInfo: '',
      deptId: 0,
      curStudent: {},
      payTerm: {
        stdt: 0, // 缴费开始日期
        endt: 0, // 缴费结束日期
        academicYear: '', // 学年
        term: '', // 学期
        isPayTerm: ''
      },
      tableData: [],  // table绑定数据
      uiSetItemList: [], // 原始
      termList: [], // 账期列表
      orderInfoList: [], // 缴费历史
      orderInfoListByType: [], // 各类型缴费历史
      viDeptSetList: [],
      // 控制属性
      feeListVisible: false,
      queryFormVisible: false,
      isAllTermPay: false,
      feeListHistoryVisible: false,
      tabSelected: 'default', // 默认显示本期账单
      formLabelWidth: '80px',
      // 标签图片
      infoVisible: false,

      feeList: [],
      feeSum: {},

      payRule: '',
      channelFlag: '01',
      merchantCode: '',
      payTypeUnion: '01', // 银联支付
      // 分页对象
      page: this.Ginkgo.cloneObj(this.global.page),
      payTypeVisible: false,
      feePayType_WX: false,
      feePayType_UN: true,
      payType: '',
      // 查询窗体
      uiSetList: [],
      route: [],
      // ！！！初始排序对象
      sort: {},
      sortSet: [],
      // 选宿舍窗体
      dormSetForm: {}, // 宿舍类型配置信息
      dormSetList: [], // 宿舍类型下拉框
      dormChooseForm: { // 选宿舍
        dormSet: '',
        flatsName: '',
        roomNo: '',
        bedNo: ''
      },
      // 选服装窗体
      clothChooseForm: {
        coatSize: '',
        shirtSize: '',
        shoesSize: ''
      },
      // 属性
      chooseDormVisible: true,
      chooseOtherVisible: false,
      showImg: false,
      // 打印报道单
      orderInfoRow: {},
      classRow: {},
      dormRow: {},
      // 公寓相关图片
      effectDrawing: this.global.staticResourceAddr + 'gsvvuemobileoif/images/xifan/newStu/4rj.jpg',
      bedDiagram: this.global.staticResourceAddr + 'gsvvuemobileoif/images/xifan/newStu/10001.png',
      size_Img: this.global.staticResourceAddr + 'gsvvuemobileoif/images/xifan/newStu/sgcm.jpg'
    }
  },
  mounted: function () {
    if (process.env.NODE_ENV === 'production') {
      var self = this

      self.getMode()
      self.getUISet()
      this.curStudent = this.global.curStudent
      this.validPayTerm() // 校验该学生是否交过费用
    } else {
      this.getUISet()
      this.validPayTerm() // 校验该学生是否交过费用
    }
  },
  watch: {
    'dormChooseForm.dormSet': 'handleDormSetChange',
    'dormChooseForm.flatsName': 'handleFlatsChange',
    'dormChooseForm.roomNo': 'handleRoomChange',
    tabSelected: 'handleSelect'
  },
  methods: {
    // 获取学生历史缴费信息
    getOrderInfoList: function () {
      var self = this
      return self.axios.get('/iif/getOrderInfoForHistory', { params: {
        deptId: self.global.deptId,
        keyInfo: self.global.curStudent.uid
      }})
      .then(function (response) {
        if (response.data.result.success === true) {
          self.orderInfoList = response.data.orderInfoList
          self.orderInfoListByType = self.orderInfoList.filter(item => item.field12 === '04')
          if (self.orderInfoListByType.length > 0) {
            self.orderInfoRow = self.orderInfoListByType[0]
            self.getPrintList()
          } else {
            self.$alert('请先缴费！')
          }
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    // 获取打印所需数据
    getPrintList: function () {
      var self = this
      self.axios.all([self.getClassList(), self.getDormList()]
      ).then(self.axios.spread(function (classDivd, dorm) {
        if (classDivd.data.result.success === true && dorm.data.result.success === true) {
          self.classRow = classDivd.data.classDivdList[0]
          self.dormRow = dorm.data.viXFDormOneList[0]
          self.toPrint()
        } else {
          self.$alert('报道单信息获取失败！')
        }
      }))
    },
    // 获取学生所选班级
    getClassList: function () {
      var self = this
      return self.axios.get('/college/getClassDivdOne', { params: {
        keyInfo: self.global.curStudent.uid,
        schoolYear: self.curStudent.enrollmentYear
      }})
    },
    // 获取学生所选床位
    getDormList: function () {
      var self = this
      return self.axios.get('/college/getViXFDorm', { params: {
        bedId: self.orderInfoRow.field13
      }})
    },
    toPrint: function () {
      let sort = {prop: 'field10', order: 'ascending'}
      let feelist = this.Ginkgo.sortList(this.orderInfoListByType, sort)
      let feeReducelist = this.orderInfoList.filter(item => item.field12 === '05')
      // 计算金额
      let feeAmount = 0.0
      for (let index = 0; index < feelist.length; index++) {
        feeAmount = feeAmount + parseFloat(feelist[index].feeAmount) * 100
      }
      feeAmount = feeAmount / 100
      let codestr = ''
      codestr += ''
      codestr += '<div style="width: 85%; height: 320px;margin: 0 auto;font-size:10px;">' +
      '<h1 style="color: rgb(9, 9, 9);height: 60px;line-height: 30px;text-align: center;margin-bottom: 10px;margin-top: 10px;font-size: 20px;">西安翻译学院新生入学报到单</h1>' +
      '<p style="color: rgb(9, 9, 9);width:50%;height:100px;float: left;line-height: 25px;text-align: left; ">' +
      '学号：' + this.curStudent.studentNo + '<br/>姓名：' + this.curStudent.studentName + '<br/>性别：' + this.curStudent.sex + '<br/>考生号：' + this.curStudent.examNo + '<br/>校园E卡通号：' + this.curStudent.studentNo + '<br/>年级：' + this.curStudent.enrollmentYear + '<br/>院（系）/部：' + this.orderInfoRow.field9 + '<br/>收费单据号：' + this.orderInfoRow.orderNo + '</p>' +
      '<p style="color: rgb(9, 9, 9);width:50%;height:100px;float: left;line-height: 25px;text-align: left; ">' +
      '专业：' + this.curStudent.majorMatr + '<br/>班级：' + this.classRow.className + '<br/>培养类别：' + this.curStudent.trainingLevel + '<br/>培养对象：' + this.curStudent.trainingObject + '<br/>联系电话：' + this.curStudent.phone + '<br/>报道日期：' + this.Ginkgo.getToday() + '<br/>交费金额：' + feeAmount + '</p></div>'
      // 明细排版
      codestr += '<div><table style="color: rgb(9, 9, 9);width: 85%; margin: 0 auto; text-align: center;border-collapse:collapse;" border="1";>' +
      '<tr style="height:36px;font-size:14px;"><td>收费项目</td><td>收费标准(元)</td><td>收费项目</td><td>收费标准(元)</td></tr>' +
      '<tr style="height:36px;font-size:12px;"><td>' + feelist[0].feeNo + '/学期</td><td>' + feelist[0].feeAmount + '</td><td>' + feelist[1].feeNo + '</td><td>' + feelist[1].feeAmount + '</td></tr>' +
      '<tr style="height:36px;font-size:12px;"><td>' + feelist[2].feeNo + '</td><td>' + feelist[2].feeAmount + '</td><td>' + feelist[3].feeNo + '</td><td>' + feelist[3].feeAmount + '</td></tr>' +
      '<tr style="height:36px;font-size:12px;"><td>' + feelist[4].feeNo + '</td><td>' + feelist[4].feeAmount + '</td><td>' + feelist[5].feeNo + '</td><td>' + feelist[5].feeAmount + '</td></tr>' +
      '<tr style="height:36px;font-size:12px;"><td>' + feelist[6].feeNo + '</td><td>' + feelist[6].feeAmount + '</td><td>' + feelist[7].feeNo + '</td><td>' + feelist[7].feeAmount + '</td></tr>'
      if (feeReducelist.length > 0) {
        codestr += '<tr style="height:36px;font-size:12px;"><td>' + feeReducelist[0].feeNo + '</td><td>' + feeReducelist[0].feeAmount + '</td>'
        if (feeReducelist.length > 1) {
          codestr += '<td>' + feeReducelist[1].feeNo + '</td><td>' + feeReducelist[1].feeAmount + '</td></tr>'
        } else {
          codestr += '<td></td><td></td></tr>'
        }
      }
      if (feeReducelist.length > 2) {
        codestr += '<tr style="height:36px;font-size:12px;"><td>' + feeReducelist[2].feeNo + '</td><td>' + feeReducelist[2].feeAmount + '</td>'
        if (feeReducelist.length > 3) {
          codestr += '<td>' + feeReducelist[3].feeNo + '</td><td>' + feeReducelist[3].feeAmount + '</td></tr>'
        } else {
          codestr += '<td></td><td></td></tr>'
        }
      }
      codestr += '</table></div>' +
      '<table style="width: 85%; margin: 0 auto;color: rgb(9, 9, 9);text-align: center;border-collapse:collapse;font-size:10px;" border="1">' +
      '<tr><td style="width: 20%;height: 80px;">01</td><td style="width:40%;">公寓中心<br/>(分配宿舍)</td><td>公寓楼：' + this.dormRow.flatsName + '<br/>房间号：' + this.dormRow.roomNo + '<br/>床位号：' + this.dormRow.bedNo + '</td></tr>' +
      '<tr><td style="width: 20%;height: 80px;">02</td><td style="width:40%;">E卡通中心<br/>(办理E卡通)</td><td>卡号：' + this.curStudent.studentNo + '</td></tr>' +
      '<tr><td style="width: 20%;height: 80px;">03</td><td style="width:40%;">公寓<br/>(领取公寓用品)</td><td>6斤棉被1床、5斤棉褥1床、4斤棉被1床、床单2条、被罩2床、枕巾1条、 枕套1个、枕芯1个、暖水瓶1个、脸盆2个</td></tr>' +
      '<tr><td style="width: 20%;height: 80px;">04</td><td style="width:40%;">军训服装<br/>(领取军服用品)</td><td>迷彩服1套(' + this.orderInfoRow.field14 + ')、迷彩衫1件(' + this.orderInfoRow.field15 + ')、军帽1项、军鞋一双(' + this.orderInfoRow.field16 + ')、马扎1个</td></tr>' +
      '<tr><td style="width: 20%;height: 80px;">05</td><td style="width:40%;">其他<br/>(到辅导员处报到)</td><td></td></tr>' +
      '<tr><td style="width: 20%;height: 80px;">06</td><td style="width:40%;">卫生所（领取查体号）</td><td></td></tr></table>'
      this.$confirm('确定要打印学号为' + this.curStudent.studentNo + '，姓名为' + this.curStudent.studentName + '的报到单吗?(请使用谷歌浏览器打印)', '提示', {
        confirmButtonText: '确定（请打印两份）',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        let newWindow = window.open('_blank') // 打开新窗口
        newWindow.document.write(codestr) // 向文档写入HTML表达式或者JavaScript代码
        newWindow.document.close() // 关闭document的输出流, 显示选定的数据
        newWindow.print() // 打印当前窗口
        setTimeout(newWindow.close(), 0)
        this.info = '打印完成！'
        return true
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    setVisible: function (showType) {
      if (showType === '01') { // 登录显示
        this.queryFormVisible = true
        this.feeListVisible = false
        this.infoVisible = false
        this.payTypeVisible = false
        this.feeListHistoryVisible = false
        this.chooseDormVisible = false
        this.chooseOtherVisible = false
      }
      if (showType === '02') { // 费用信息
        this.queryFormVisible = false
        this.feeListVisible = true
        this.infoVisible = false
        this.payTypeVisible = false
        this.feeListHistoryVisible = false
        this.chooseDormVisible = false
        this.chooseOtherVisible = false
      }
      if (showType === '03') { // 支付按钮
        this.queryFormVisible = false
        this.feeListVisible = false
        this.infoVisible = false
        this.payTypeVisible = true
        this.feeListHistoryVisible = false
        this.chooseDormVisible = false
        this.chooseOtherVisible = false
      }
      if (showType === '04') { // 缴费历史
        this.queryFormVisible = false
        this.feeListVisible = false
        this.infoVisible = false
        this.payTypeVisible = false
        this.feeListHistoryVisible = true
        this.chooseDormVisible = false
        this.chooseOtherVisible = false
      }
      if (showType === '06') { // 提示信息
        this.queryFormVisible = false
        this.feeListVisible = false
        this.infoVisible = true
        this.payTypeVisible = false
        this.feeListHistoryVisible = false
        this.chooseDormVisible = false
        this.chooseOtherVisible = false
      }
      if (showType === '07') { // 选宿舍
        this.queryFormVisible = false
        this.feeListVisible = false
        this.infoVisible = false
        this.payTypeVisible = false
        this.feeListHistoryVisible = false
        this.chooseDormVisible = true
        this.chooseOtherVisible = false
      }
      if (showType === '08') { // 选服装
        this.queryFormVisible = false
        this.feeListVisible = false
        this.infoVisible = false
        this.payTypeVisible = false
        this.feeListHistoryVisible = false
        this.chooseDormVisible = false
        this.chooseOtherVisible = true
      }
    },
    // 初始化数据字典
    getMode: function () {
      var self = this
      self.modeSelectList = self.global.modeList
    },
    // 加载界面配置
    getUISet: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        self.uiSetItemList = self.global.uiSetItemList
        self.uiSetList = self.global.uiSetList
      } else {
        this.uiSetList = [
          {uiSetId: 'vi_House_PayFeeOif', uiSetName: '范例', uiSetType: '01', uiSetTypeDesc: '管理', colWidthOpt: '125', exportTextSet: '', crossItemNo: 'feeNo', crossItemName: 'feeName', mergeCell: '', sortSet: 'building,01', remark: '', itemList: null}
        ]
        this.uiSetItemList = [
          {uiSetId: 'vi_House_PayFeeOif', columnName: 'Dept_ID', columnDesc: '机构ID', columnProp: 'deptId', isVisible: '0', sortNo: '01', queryCondition: '0', sortNoQuery: '01', controlType: '02', controlTypeDesc: null, typeId: 'Dept', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '0', sortNoResult: '01', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null},
          {uiSetId: 'vi_House_PayFeeOif', columnName: 'Dept_NO', columnDesc: '机构号', columnProp: 'deptNo', isVisible: '0', sortNo: '01|01', queryCondition: '0', sortNoQuery: '01', controlType: '02', controlTypeDesc: null, typeId: 'Dept', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '0', sortNoResult: '01|01', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null},
          {uiSetId: 'vi_House_PayFeeOif', columnName: 'Dept_Name', columnDesc: '机构', columnProp: 'deptName', isVisible: '0', sortNo: '01|02', queryCondition: '0', sortNoQuery: '01', controlType: '02', controlTypeDesc: null, typeId: 'Dept', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '01|02', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null},
          {uiSetId: 'vi_House_PayFeeOif', columnName: 'Room_Type', columnDesc: '公寓等级', columnProp: 'dormSet', isVisible: '1', sortNo: '02', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '02', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null},
          {uiSetId: 'vi_House_PayFeeOif', columnName: 'Building', columnDesc: '公寓楼', columnProp: 'building', isVisible: '1', sortNo: '03', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '03', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null},
          {uiSetId: 'vi_House_PayFeeOif', columnName: 'Room', columnDesc: '宿舍号', columnProp: 'room', isVisible: '1', sortNo: '04', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '1', queryVisible: '1', sortNoResult: '04', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null},
          {uiSetId: 'vi_House_PayFeeOif', columnName: 'Beds', columnDesc: '床位号', columnProp: 'beds', isVisible: '1', sortNo: '05', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null},
          {uiSetId: 'vi_Clothing_PayFeeOif', columnName: 'Clothes', columnDesc: '迷彩服号', columnProp: 'clothes', isVisible: '1', sortNo: '01', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'Clothes_Size', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null},
          {uiSetId: 'vi_Clothing_PayFeeOif', columnName: 'Dress', columnDesc: '迷彩衫号', columnProp: 'dress', isVisible: '1', sortNo: '02', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'Dress_Size', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null},
          {uiSetId: 'vi_Clothing_PayFeeOif', columnName: 'Shoes', columnDesc: '鞋子尺码', columnProp: 'shoes', isVisible: '1', sortNo: '05', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'Shoes_Size', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null}
        ]
      }
    },
    // 加载所有宿舍类型
    getDormSet: function () {
      var self = this
      return self.axios.post('/college/getViXFDormSet', {})
    },
    // 加载所有可选宿舍，并进行数据字典化（宿舍类型Type_ID:Dorm_Set;公寓Type_ID:Flats;房间Type_ID:Room;床位Type_ID:Bed;）
    getDorm: function () {
      var self = this
      return self.axios.post('/college/getViXFDormForChoose', {
        enrollmentYear: this.curStudent.enrollmentYear,
        majorName: this.curStudent.majorName,
        trainingLevel: this.curStudent.trainingLevel,
        sex: this.curStudent.sex,
        keyInfo: this.curStudent.uid
      })
    },
    // 校验该学生是否缴过费
    validOrderInfo: function () {
      var self = this
      if (process.env.NODE_ENV === 'production') {
        this.axios.post('/college/getXFOrderInfoForCheck', {
          field1: this.curStudent.studentName,
          keyInfo: this.curStudent.uid,
          field12: '04',
          statusCode: '00'
        })
        .then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.orderInfoList.length > 0) { // 有缴费记录
              self.info = '已缴费！'
              self.setVisible('06') // 提示信息
            } else {
              // 进入缴费流程
              self.initThis()
            }
          } else {
            self.$alert('系统错误！')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    // 加载缴费基础信息
    initThis: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        self.getMode()
        self.axios.all([self.getDorm()]
        ).then(this.axios.spread(function (dorm) {
          if (dorm.data.result.success === true) {
            self.dormList = dorm.data.viXFDormList
            self.modeSelectList = self.modeSelectList.concat(dorm.data.modeList)
            self.dormSetList = dorm.data.viXFDormSetList
            // 初始化宿舍选择
            if (self.modeSelector('Flats').length > 0) {
              // 公寓选择初始化成第一个公寓
              self.dormChooseForm.flatsName = self.modeSelector('Flats')[0].modeId
              // 宿舍配置初始化成该公寓的首个类型
              if (self.modeSelector('Dorm_Set').length > 0) {
                // 初始化宿舍配置为首个公寓首个宿舍类型的信息
                self.dormChooseForm.dormSet = self.modeSelector('Dorm_Set')[0].modeId
                // 根据所选宿舍类型加载宿舍类型信息
                self.setDormSet(self.dormChooseForm.dormSet)
              }
            }
          }
          if (self.dormList.length > 0) {
            self.setVisible('07') // 选宿舍
          } else {
            self.info = '无可选宿舍床位！'
            self.setVisible('06') // 提示信息
          }
        }))
      } else {
        this.dormSetForm = {
          dormSet: '',
          price: '1000',
          dormStandard: '',
          roomSet: '',
          pubAreaSet: '',
          region: '',
          remark: ''
        }
      }
    },
    // 重置编辑窗体
    resetForm: function () {
      this.setVisible('01')
    },
    // 校验是否在缴费期中
    validPayTerm: function () {
      var self = this
      if (process.env.NODE_ENV === 'production') {
        let termInfo = this.modeSelector('CommMode_NewStuPayTime')
        .filter(item => item.modeValue.substring(0, 4) === this.curStudent.enrollmentYear.toString())
        if (termInfo.length > 0) { // 新生只判断学年
          self.payTerm.stdt = termInfo[0].field2
          self.payTerm.endt = termInfo[0].field3
          self.payTerm.academicYear = termInfo[0].modeValue
          self.payTerm.term = termInfo[0].field1

          let newDate = self.Ginkgo.dateToInt(new Date())
          if (newDate >= self.payTerm.stdt && newDate <= self.payTerm.endt) {
            // 校验账单
            self.validOrderInfo()
          } else {
            self.info = '缴费未开始！'
            self.setVisible('06') // 提示信息
          }
        } else {
          this.info = '缴费未开始！'
          this.setVisible('06') // 提示信息
        }
      } else {
        this.setVisible('07') // 选宿舍
      }
    },
    // 获取机构支付配置
    getDeptSet: function () {
      var self = this
      self.axios.get('/public/getBaseDeptSetByDeptID', { params: {
        deptId: self.global.deptId
      }})
      .then(function (response) {
        // 机构配置信息
        if (response.data.result.success === true) {
          let wxPayType = response.data.viDeptSetList.filter(item => item.payType === '02' || item.payType === '03' || item.payType === '98')
          if (wxPayType.length > 0) { // 有且仅有一个
            self.channelFlag = wxPayType[0].channelFlag
            self.merchantCode = wxPayType[0].merchantCode
          }
          self.doPay('14')
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    setVisiblePayButton: function (deptSetList) {
      var self = this
      self.feePayType_UN = false
      self.feePayType_WX = false
      // 机构配置信息
      if (deptSetList.length > 0) {
        self.payRule = deptSetList[0].payRule
        if (self.payRule === '03') {
          self.isAllTermPay = true
        } else {
          self.isAllTermPay = false
        }
        deptSetList.forEach(function (e) {
          if (e.payType === '01' || e.payType === '14') {
            self.payTypeUnion = e.payType
            self.feePayType_UN = true
          } else if (e.payType === '02' || e.payType === '03' || e.payType === '99') {
            self.payType = e.payType
            self.feePayType_WX = true
          }
        })
      }
    },
    // 获取学生历史缴费信息
    getHistory: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        self.axios.get('/iif/getOrderInfoForHistory', { params: {
          deptId: self.global.deptId,
          keyInfo: self.global.curStudent.uid
        }})
        .then(function (response) {
          // 机构配置信息
          if (response.data.result.success === true) {
            self.orderInfoList = response.data.orderInfoList
            self.getHistoryByType('04')
            self.setVisible('04')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.uiSetItemList = [
          {uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'transDt', columnDesc: '日期', columnProp: 'transDt', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
          {uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'feeAmount', columnDesc: '费用', columnProp: 'feeAmount', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
          {uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'orderNo', columnDesc: '订单号', columnProp: 'orderNo', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''}
        ]
        this.orderInfoList = [
          {transDt: '20180730', feeAmount: 100, orderNo: 'xxxxxxxxxxxxxxxx'}
        ]
        this.page.totalElements = this.orderInfoList.length
        this.loadCurrentPageHistory()
        this.setVisible('04')
      }
    },
    // 点击去支付按钮
    toPay: function (feeTypes) {
      if (process.env.NODE_ENV === 'production') {
        this.checkPayTime()
      } else {
        this.setVisible('03')
      }
    },
    // 校验商户缴费期
    checkPayTime: function (feeTypes) {
      var self = this
      self.axios.get('/pay/checkToPay', { params: {
        deptId: self.global.deptId // 1000003
      }})
      .then(function (response) {
        if (response.data.return_msg === 'SUCCESS') {
          // 设置账期列表
          if (self.feeList.length > 0) {
            self.termList = []
            self.feeList.forEach(function (item) {
              self.termList.push(item.term)
            })
            self.getDeptSet()
          } else {
            self.$alert('无待缴账单！')
          }
        } else {
          self.$alert(response.data.prop)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    doPay: function (payType) {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        let payUrl = ''
        let validType = '02'
        self.axios.post('/college/getOrderInfoIsExpired', {
          keyInfo: self.curStudent.uid,
          deptId: self.global.deptId,
          term: self.termList[0]
        })
        .then(function (response) {
          if (response.data.result.success) {
            // 根据不同支付方式访问不同的发起交易服务
            self.axios.post('/pay/toPay', {
              keyInfo: self.curStudent.uid,
              deptId: self.global.deptId,
              payType: payType,
              feeTermList: self.termList,
              validType: validType
            })
            .then(function (response) {
              if (response.data.result.success) {
                if (payType === '02' || payType === '03' || payType === '98') { // 微信支付
                  if (self.channelFlag === '02') {
                    payUrl = self.global.wechatAuthUrl + '?state=' + self.merchantCode + ';payType:' + payType + ';orderNo:' + response.data.orderNo + ';deptId:' + response.data.deptId + ';payChannel:02'
                  } else {
                    payUrl = self.global.wechatAuthUrl + '?state=99999;payType:' + payType + ';orderNo:' + response.data.orderNo + ';deptId:' + response.data.deptId + ';payChannel:02'
                  }
                } else { // 其他
                  payUrl = self.global.payUrl + 'public/doPay?' + 'payType=' + payType + '&orderNo=' + response.data.orderNo + '&deptId=' + response.data.deptId + '&openId=&payChannel=02'
                }
                window.location.href = payUrl
              } else {
                self.$alert(response.data.result.msg)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
          } else {
            self.$alert(response.data.result.msg)
            // 超时，重新加载选宿舍基础信息，进入选宿舍界面
            self.initThis()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.setVisible('01')
      }
    },
    back: function (type) {
      this.setVisible(type)
    },
    // 数据字典筛选器
    modeSelector: function (typeId) {
      let list = []
      switch (typeId) {
        case 'Dorm_Set':
          list = this.modeSelectList.filter(item => item.typeId === typeId && item.parentModeId === this.dormChooseForm.flatsName)
          break
        case 'Room':
          list = this.modeSelectList.filter(item => item.typeId === typeId && item.parentModeId === this.dormChooseForm.dormSet)
          break
        case 'Bed':
          list = this.modeSelectList.filter(item => item.typeId === typeId && item.parentModeId === this.dormChooseForm.roomNo && item.modeValue === this.dormChooseForm.flatsName)
          break
        default:
          list = this.modeSelectList.filter(function (element) {
            return element.typeId === typeId
          })
          break
      }
      return list
    },
    // 编辑窗体禁用 01 新增 02 修改
    getDisableEdit: function (propName, formName) {
      let disabled = false
      // 宿舍类型
      if (this.dormChooseForm.flatsName === '') {
        if (propName === 'dormSet' || propName === 'roomNo' || propName === 'bedNo') {
          disabled = true
        }
      } else {
        if (propName === 'dormSet') {
          disabled = false
        }
      }
      // 宿舍
      if (this.dormChooseForm.dormSet === '') {
        if (propName === 'roomNo' || propName === 'bedNo') {
          disabled = true
        }
      } else {
        if (propName === 'roomNo') {
          disabled = false
        }
      }

      // 床位
      if (this.dormChooseForm.roomNo === '') {
        if (propName === 'bedNo') {
          disabled = true
        }
      } else {
        disabled = false
      }
      return disabled
    },
    // 校验选择宿舍窗体
    validForm: function () {
      let valid = true
      if (this.dormChooseForm.dormSet === '') {
        this.$alert('请选择公寓等级！')
        return false
      }
      if (this.dormChooseForm.flasName === '') {
        this.$alert('请选择公寓楼！')
        return false
      }
      if (this.dormChooseForm.roomNo === '') {
        this.$alert('请选择宿舍！')
        return false
      }
      if (this.dormChooseForm.bedNo === '') {
        this.$alert('请选择床位！')
        return false
      }
      if (this.bedDiagram === '') {
        this.$alert('选择的床位出现异常！')
        return false
      }
      return valid
    },
    // 校验选择军训服窗体
    validClothForm: function () {
      let valid = true
      if (this.clothChooseForm.coatSize === '') {
        this.$alert('请选择迷彩服尺码！')
        return false
      }
      if (this.clothChooseForm.shirtSize === '') {
        this.$alert('请选择迷彩衫尺码！')
        return false
      }
      if (this.clothChooseForm.shoesSize === '') {
        this.$alert('请选择鞋子尺码！')
        return false
      }
      return valid
    },
    // 选择宿舍
    chooseDorm: function () {
      if (process.env.NODE_ENV === 'production') {
        if (this.validForm()) {
          var self = this
          // 根据选择的床位筛选当前的宿舍床位对象（为了取ID）
          this.chosenDorm = this.dormList.filter(item => item.flatsName === this.dormChooseForm.flatsName && item.roomNo === this.dormChooseForm.roomNo && item.bedNo === this.dormChooseForm.bedNo)[0]
          // 校验所选宿舍是否已经被其他人所选
          self.axios.post('/college/lockDormBed', {
            bedId: this.chosenDorm.id,
            keyInfo: self.curStudent.uid
          })
          .then(function (response) {
            if (response.data.result.success === true) {
              self.setVisible('08')
            } else {
              self.$alert(response.data.result.msg)
            }
          }, response => {
          })
          .catch(function (error) {
            console.log(error)
          })
        }
      } else {
        this.setVisible('08')
      }
    },
    // 选择军训服装
    chooseOther: function () {
      if (process.env.NODE_ENV === 'production') {
        if (this.validClothForm()) { // 校验选择服装
          // 创建订单
          this.createOrderInfo()
        }
      } else {
        this.setVisible('02')
      }
    },
    // 创建订单
    createOrderInfo: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        let order = {}
        order.studentName = this.curStudent.studentName
        order.uid = this.curStudent.uid
        order.bedId = this.chosenDorm.id
        order.coatSize = this.clothChooseForm.coatSize
        order.shirtSize = this.clothChooseForm.shirtSize
        order.shoesSize = this.clothChooseForm.shoesSize

        // 校验所选宿舍是否已经被其他人所选
        self.axios.post('/college/addXFOrderInfo', order)
        .then(function (response) {
          if (response.data.result.success === true) {
            self.feeList = response.data.orderInfoList
            if (response.data.orderInfoSumList.length > 0) {
              self.feeSum = response.data.orderInfoSumList[0]
            }
            self.setVisible('02')
          } else {
            self.$alert(response.data.result.msg)
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    // 下一步
    nextStep: function (optName) {
      if (optName === 'Dorm') {
        this.chooseDorm()
      } else {
        this.chooseOther()
      }
    },
    clickImg: function (e) {
      this.showImg = true
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src
    },
    viewImg: function () {
      this.showImg = false
    },
    handleSelect: function (index, indexPath) {
      if (process.env.NODE_ENV === 'production') {
        if (index === '/MyBill') {
          this.validPayTerm()
        }
        if (index === '/MyBillHistory') {
          this.tableData = []
          this.getHistory()
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan')
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }]
          this.$router.addRoutes(this.route)
        }
        if (index === '/Print') {
          this.info = '待打印！'
          this.setVisible('06')
          this.getOrderInfoList()
        }
      } else {
        if (index === '/MyBill') {
          this.setVisible('02')
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan')
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }]
          this.$router.addRoutes(this.route)
        }
        if (index === '/Print') {
          this.toPrint()
        }
      }
    },
    // 根据费用类型获取对应的缴费历史记录
    getHistoryByType: function (type) {
      var self = this
      // this.orderInfoListByType = this.orderInfoList.filter(item => item.field12 === type)
      this.orderInfoListByType = this.orderInfoList
      // 首次默认排序
      self.handleSortChangeHistory(self.sort)
      // 分页处理
      self.page.totalElements = self.orderInfoListByType.length
      self.loadCurrentPageHistory()
      // 设置当前选中行
      self.setCurrentRowHistory()
    },
    // 获取查询结果配置
    getUISetQueryResult: function (form) {
      let setId = form === '01' ? 'tbIf_Order_Info_XiFan' : 'tbIf_Order_Info_XiFan_Exam'
      let sort = {prop: 'sortNoResult', order: 'ascending'}

      let list = this.uiSetItemList.filter(function (element) {
        return element.uiSetId === setId && element.queryVisible === '1'
      })

      return this.Ginkgo.sortList(list, sort)
    },
    // 列数据格式化
    dataFormatHistory: function (row, column, cellValue) {
      var columnProp = column.property
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('01').filter(function (element) {
        return element.columnProp === columnProp
      })[0].formatString

      return this.Ginkgo.format(cellValue, formatString)
    },
    // 列可见性
    getHeaderVisible: function (item, level, fixed) {
      return this.Ginkgo.getHeaderVisible(item, level, fixed)
    },
    // 获取同组记录
    getHeaderGroup: function (item, level, form) {
      return this.Ginkgo.getHeaderGroup(item, level, this.getUISetQueryResult(form))
    },
    // 排序(参数var={prop,order}) order: ascending  descending
    handleSortChangeHistory: function (val) {
      this.sort = val
      let sorts = this.Ginkgo.cloneObj(this.sortSet)
      sorts.pop() // 删除最后一个对象（最后一个对象根据界面列点击改变）
      sorts.push(val)
      this.orderInfoListByType = this.Ginkgo.sort(this.orderInfoListByType, sorts)
      this.loadCurrentPageHistory()
    },
    // 选中当前行
    setCurrentRowHistory: function () {
      if (this.currentIndex !== -1) {
        this.$refs.resultTable.setCurrentRow(this.tableData[this.currentIndex])
      }
    },
    // 加载当前页内容
    loadCurrentPageHistory: function () {
      this.tableData = this.orderInfoListByType.slice(this.page.number * this.page.size, (this.page.number + 1) * this.page.size)
    },
    // 查询结果每页显示条数改变事件
    handleSizeChangeHistory: function (val) {
      this.page.size = val
      this.loadCurrentPageHistory()
    },
    // 页码改变事件
    handleCurrentChangeHistory: function (val) {
      this.page.number = val - 1
      this.loadCurrentPageHistory()
    },
    // 切换dormSetForm的取值
    setDormSet: function (dormSet) {
      let listDorm = this.dormSetList.filter(item => item.flatsName + item.dormSet + item.dormStandard + item.direction === dormSet)
      if (listDorm.length > 0) {
        this.dormSetForm = listDorm[0]
        this.effectDrawing = this.global.staticUploadAddr + this.dormSetForm.effectDrawing
        this.bedDiagram = this.global.staticUploadAddr + this.dormSetForm.bedDiagram
      } else {
        this.dormSetForm = {}
        this.effectDrawing = ''
        this.bedDiagram = ''
      }
    },
    // 宿舍类型下拉框change
    handleDormSetChange: function (val) {
      console.log('ttttttttt', val)
      if (val) {
        this.setDormSet(val)
        this.dormChooseForm.roomNo = ''
        this.dormChooseForm.bedNo = ''
      }
    },
    // 宿舍下拉框change
    handleFlatsChange: function (val) {
      let list = this.modeSelector('Dorm_Set')
      if (list.length > 0) {
        this.dormChooseForm.dormSet = list[0].modeId
        this.setDormSet(this.dormChooseForm.dormSet)
      }
      this.dormChooseForm.roomNo = ''
      this.dormChooseForm.bedNo = ''
    },
    // 床位下拉框change
    handleRoomChange: function (val) {
      this.dormChooseForm.bedNo = ''
    },
    // 操作列可见性
    getOpVisible: function (form) {
      return this.Ginkgo.getOpVisible(this.getUISetQueryResult(form))
    }
  }
}
</script>
<style>
  .query-fee{
    text-align: center;
    margin: 5px 0 5px 0;
    background: #fff;
  }
  .content-icons{
    float:left;
    width:25%;
    height:35%;
    margin: 5px 0;
    text-decoration:none;
    color:#333;
  }
  .content-imgs{
    width: 19vw;
    height: 19vw;
  }
  .label_detail {
    margin: 0px 0px 0px 20px;
  }
  .label_value {
    margin: 0px 30px 0px 0px;
    float: right;
    /* width: 40% */
  }
  .form-item {
    height: 40px;
    line-height: 40px;
    color: #303133;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    font-weight: 500;
    transition: border-bottom-color .3s;
    outline: 0;
    background-color: #fff;
    /* margin-bottom: 2px; */
    margin-left: 5px;
  }
  .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
  .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
    line-height: 40px !important;
  }
  .el-collapse-item__header {
    text-align: left;
    height: 40px;
    line-height: 40px;
    color: #303133;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    font-weight: 500;
    transition: border-bottom-color .3s;
    outline: 0;
    background-color: #fff;
    margin-left: 5px;
  }
  .deg-title{
    text-align: center !important;
    border-top: 1px solid #ffffff;
    background: #ffffff !important;
    line-height: 50px;
    margin-bottom: 20px;
    border-radius: 3px;
    font-size: 20px;
    font-weight: 600;
    color: red;
  }
</style>


// WEBPACK FOOTER //
// MyBillXiFanNew.vue?69a6d74f